import './style.scss';
import CurrentTime from './CurrentTime/CurrentTime';
import BookList from './BookList';
import React, { useContext, useEffect } from 'react';
import CurrentTimeContext from '../../context/TimeContext';
import classnames from 'classnames';
import CommonContext from '../../context/CommonContextProvider';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { getBookings, getPlaceInfo } from '../../redux/acions/oneBoardActions';
import moment from 'moment';
import Client from '../../services/api';

function OneBoardLayout({ getBookings, getPlaceInfo, zone_filters, zone_info }) {
  const { currentBook, bookForCheckIn, fetchRanges } = useContext(CurrentTimeContext);
  const {
    data: { screenHandle },
  } = useContext(CommonContext);
  const params = useParams();
  const placeId = params['placeId'] || '';

  const fetchBooks = () => {
    const { startRange, endRange } = fetchRanges;
    const start = moment(startRange).format();
    const end = moment(endRange).format();
    getBookings(start, end, placeId);
  };

  useEffect(() => {
    fetchBooks();
  }, [fetchRanges]);

  useEffect(() => {
    let timer;
    timer = setInterval(() => fetchBooks(), 5000);
    return () => clearTimeout(timer);
  }, [fetchRanges, placeId]);

  useEffect(() => {
    getPlaceInfo(placeId);
  }, []);

  const makeCheckIn = async () => {
    Client.put(`api/v1/admin/bookings/${bookForCheckIn._id}/checkin`, {})
      .then(() => fetchBooks())
      .catch((err) => console.log('makeCheckIn error', err));
  };

  const isAvailable = currentBook.book?.isEmpty || currentBook.index === -1;

  return (
    <div className={classnames('oneBoardLayout', { bgGreen: isAvailable })}>
      <div className="oneBoardContainer">
        <div className="headerBlock">
          <section className="currentDataSection">
            <CurrentTime />
          </section>
          <section className="logoSection">
            <img src={process.env.PUBLIC_URL + '/logo.png'} alt="logo" />
            <span>inspace</span>
          </section>
        </div>
        <div className="contentBlock">
          <div className="zoneInfoBlock">
            <h1>{isAvailable ? 'Available' : 'Booked'}</h1>
            <div className="zoneDetailsInfoBlock">
              <p className="roomNameP">{zone_info.name || ''}</p>
              <section className="detailsSection">
                <ol>
                  {zone_filters.map(({ filter, value }, index, arr) => {
                    const count = typeof value === 'boolean' ? '' : `${value} `;
                    let text = `${filter.title.replace(/Number of/i, '').trim()}`;
                    if (text.startsWith('Seat')) {
                      text = parseInt(count) === 1 ? 'seat' : 'seats';
                    }
                    let content = `${count} ${text}`;
                    return (
                      <li key={index}>
                        {content}
                        <span className={classnames({ spanDot: arr.length - 1 !== index })} />
                      </li>
                    );
                  })}
                </ol>
              </section>
            </div>
            {bookForCheckIn && (
              <button onClick={makeCheckIn} className="checkInBtn bgGreen">
                Check in
              </button>
            )}
            <div className="zoneInfoBottomBlock">
              <small className="poweredBy">Powered by inspace</small>
              <img
                className="fullScreenImg"
                onClick={() => (screenHandle.active ? screenHandle.exit() : screenHandle.enter())}
                src={process.env.PUBLIC_URL + (screenHandle.active ? '/norm_screen.svg' : '/full_screen.svg')}
                alt=""
              />
            </div>
          </div>
          <div className="listBooksBlock">
            <BookList />
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ one_board }) => ({
  zone_filters: one_board.zone_filters,
  zone_info: one_board.zone_info,
});

const mapDispatchToProps = {
  getBookings,
  getPlaceInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(OneBoardLayout);
